import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SmartSmsRequestPeriodicPatterns } from 'src/app/core/api/models';
import { TranslationModule } from '../../../../../i18n/translation.module';
import { SelectorCardComponent } from '../../../../../shared/components/selector-card/selector-card.component';
import { ModalTitleComponent } from '../../../../../shared/global/modal-title/modal-title.component';
import {
  SmartSmsPeriodicPatternsStateService,
  SmartSmsRequestPeriodicPatternsDialogData,
} from './smart-sms-periodic-patterns.service';
import { CalenderComponent } from 'src/app/pages/facility/calendar-event/calender/calender.component';

@Component({
    selector: 'smart-sms-request-periodic-patterns-form',
    imports: [
        CommonModule,
        TranslationModule,
        CalenderComponent,
        ModalTitleComponent,
        SelectorCardComponent,
    ],
    templateUrl: './smart-sms-request-periodic-patterns-dialog-form.component.html'
})
export class SmartSmsRequestPeriodicPatternsDialogFormComponent {
  currentService = inject(SmartSmsPeriodicPatternsStateService);

  get SmartSmsRequestPeriodicPatterns() {
    return SmartSmsRequestPeriodicPatterns;
  }

  constructor(
    private dialogRef: MatDialogRef<SmartSmsRequestPeriodicPatternsDialogFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: SmartSmsRequestPeriodicPatternsDialogData
  ) {
    if (!data.periodicPattern)
      this.data.periodicPattern = SmartSmsRequestPeriodicPatterns.DaysOfWeek;
    this.onSelectPeriodicPattern(this.data.periodicPattern);
  }

  onClose() {
    this.dialogRef.close(this.data);
  }

  onSelectPeriodicPattern(pattern: SmartSmsRequestPeriodicPatterns) {
    if(this.data.isReadonly)return;
    this.data.periodicPattern = pattern;
    this.data.calenderItems = this.currentService.applyPeriodicPattern(
      this.data.calenderItems,
      pattern
    );
  }

  onSelectAll(selected: boolean) {
    if(this.data.isReadonly)return;
    this.data.calenderItems = this.currentService.selectAll(
      this.data.calenderItems,
      selected
    );
    if (selected)
      this.data.periodicPattern = SmartSmsRequestPeriodicPatterns.DaysOfWeek;
    else this.data.periodicPattern = SmartSmsRequestPeriodicPatterns.Custom;
  }
}
